import { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { apiV1 } from '../../../../../Auth/Interceptor';

function CategoryCollectionDesktop({ item }) {
    const [productsList, setProductsList] = useState([]);

    useEffect(() => {
        async function fetchCollectionProducts() {
            try {
                const response = await apiV1.get(`collection/${item.item.categoryCollectionList[0]}`);
                if(response.status === 200) {
                    setProductsList(response.data.data.product);
                }
            }
            catch(err) {
                console.log(err);
            }
        }

        item.item.categoryCollectionList[0] && fetchCollectionProducts();
    }, [item]);

    return (
        <div className='w-full px-3 flex flex-col gap-2'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[12px] leading-[18px] text-[#000000]'>{item.item.name}</p>

                <p className='font-semibold text-[8.86px] leading-[15.5px] text-[#64DD17]'>See all</p>
            </div>

            <div className="grid grid-cols-5 gap-x-2 gap-y-2">
                {productsList?.map(product => {
                    return (
                        <ProductCard 
                            key={product.id} 
                            product={product} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default CategoryCollectionDesktop;
